/**
 * 补丁命令参数模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const patchCommandProperty = {
  // 新增或者编辑
  createOrUpdatePatchCommandProperty(params) {
    return $http.post(`${global.API_URL}/sme/patchCommandProperty/createOrUpdatePatchCommandProperty`,params);
  },
  // 查询
  select(id,params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/patchCommandProperty/select`,param);
  }
}

export default patchCommandProperty;



// WEBPACK FOOTER //
// ./src/api/patchCommandProperty.js